import React from "react";
import Cleave from "cleave.js/react"
import "cleave.js/dist/addons/cleave-phone.br"
import Axios from 'axios'
import { Link } from 'react-router-dom';

export class PreencherCadastro extends React.Component {
  constructor(props) {
super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      nome: JSON.parse(localStorage.getItem("user")).nome,
      email : JSON.parse(localStorage.getItem("user")).email,
      telefone: JSON.parse(localStorage.getItem("user")).telefone,
      cpf: JSON.parse(localStorage.getItem("user")).cpf,
      endereco: JSON.parse(localStorage.getItem("user")).endereco,
      bairro: JSON.parse(localStorage.getItem("user")).bairro,
      cidade: JSON.parse(localStorage.getItem("user")).cidade,
      estado: JSON.parse(localStorage.getItem("user")).estado,
      senha: '',
      confirmarSenha: ''
    }
    this.initAlizer();
  }

  initAlizer(){
    var user = JSON.parse(localStorage.getItem("user"));
    
    if(user.telefone == undefined) user = {...user, telefone: ''}
    if(user.cpf == undefined) user = {...user, cpf: ''}
    if(user.endereco == undefined) user = {...user, endereco: ''}
    if(user.bairro == undefined) user = {...user, bairro: ''}
    if(user.cidade == undefined) user = {...user, cidade: ''}
    if(user.estado == undefined) user = {...user, estado: ''}

    this.setState({
      nome : user.nome, 
      email: user.email, 
      telefone: user.telefone, 
      cpf: user.cpf,
      endereco: user.endereco,
      bairro: user.bairro,
      cidade: user.cidade,
      estado: user.estado,
    })
  }

  handlerChange(e){
    const {name, value} = e.target;
    this.setState({...this.state, [name] : value})
    console.log(this.state)
  }

  async atualizarCliente(e){
    if(this.state.telefone != undefined && this.state.endereco != undefined && this.state.bairro != undefined && this.state.cidade != undefined && this.state.estado != undefined){
        if(this.state.telefone.length == 0)
        {
          alert("Preencha seu telefone corretamento!")
        return ;
      }
        if(this.state.endereco.length == 0)
        {
        alert("Preencha seu endereço corretamento!")
        return ;}
        if(this.state.bairro.length == 0)
        {
        alert("Preencha seu bairro corretamento!")
        return;}
        if(this.state.cidade.length == 0)
        {
        alert("Preencha sua cidade corretamento!")
        return;
        }
        if(this.state.estado.length == 0)
        {
          alert("Preencha seu estado corretamento!")
          return;
        }
        if(this.state.senha != "" && this.state.confirmarSenha != this.state.senha){
          alert("Confirme a senha, os campos não conferem!")
          return;
        }
        if(this.state.senha == ""){
          alert("Preencha sua senha corretamento!")
          return;
          // try {
          //   var axiosInstance = new Axios.create({
          //     baseURL: window.localStorage.getItem("apiUrl")
          //   });
          //   const response = await axiosInstance.post("usuarios/atualizar-cliente", 
          //   {
          //     id: this.state.user._id,
          //     endereco: this.state.endereco,
          //     bairro: this.state.bairro,
          //     cidade: this.state.cidade,
          //     estado: this.state.estado,
          //     telefone: this.state.telefone,
          //   });
          //   alert("Atualizado com sucesso")
          //   if(response.data)
          //     window.location.href ='/loja-cliente'

          // } catch (err) {
          //   console.log(err);
          // }
        }
        else{

          try {
            var axiosInstance = new Axios.create({
              baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("usuarios/atualizar-cliente-com-senha", 
            {
              id: this.state.user._id,
              endereco: this.state.endereco,
              bairro: this.state.bairro,
              cidade: this.state.cidade,
              estado: this.state.estado,
              telefone: this.state.telefone,
              senha: this.state.senha,
            });

            alert("Atualizado com sucesso")
            if(response.data)
            this.props.history.push('/loja-cliente')

          } catch (err) {
            console.log(err);
          }

        }
    }
    else{
      alert("Preencha os campos vazios!")
      this.initAlizer()
    }
  }


  render() {
    return (
      <div className="container p-5" style={window.screen.width > 700? {maxWidth: '600px'} : {}}>
        <div className="row m-1">
             <h4>ATUALIZE SEU CADASTRO</h4>
        </div>
        <div className="row m-1">
             <input className="form-control" name="nome" value={this.state.nome} placeholder="NOME COMPLETO" disabled="true" ></input>
        </div>

        <div className="row m-1">
             <input className="form-control" name="email" value={this.state.email} placeholder="EMAIL"  disabled="true" ></input>
        </div>
        <Cleave placeholder="999.999.999-99"
                            value={this.state.cpf}
                            name="cpf" data-length="11"
                            className={`form-control`}
                            options={{
                                numericOnly: true,
                                delimiters: ['.', '.', '-'],
                                blocks: [3, 3, 3, 2]
                            }}
                            onChange={this.handlerChange.bind(this)}
                    />
        <div className="row m-1">
        <Cleave name="telefone"
                            placeholder="99 99999 9999"
                            data-length="10"
                            value={this.state.telefone}
                            className="form-control"
                            options={{
                                phone: true,
                                phoneRegionCode: 'BR'
                            }}
                            onChange={this.handlerChange.bind(this)}
                    />
        </div>

        <div className="row m-1">
             <input className="form-control" name="endereco" value={this.state.endereco} placeholder="RUA E NUMERO DA CASA"  onChange={this.handlerChange.bind(this)} ></input>
        </div>

        <div className="row m-1">
             <input className="form-control" name="bairro" value={this.state.bairro} placeholder="BAIRRO"  onChange={this.handlerChange.bind(this)} ></input>
        </div>

        <div className="row m-1">
             <input className="form-control" name="cidade" value={this.state.cidade} placeholder="CIDADE"  onChange={this.handlerChange.bind(this)} ></input>
        </div>

        <div className="row m-1">
             <input className="form-control" name="estado" value={this.state.estado} placeholder="ESTADO"  onChange={this.handlerChange.bind(this)} ></input>
        </div>
        <div className="row m-1 mt-3">
             <input className="form-control" name="senha"  placeholder="NOVA SENHA"  onChange={this.handlerChange.bind(this)} ></input>
        </div>
        <div className="row m-1">
             <input className="form-control" name="confirmarSenha" value={this.state.confirmarSenha} placeholder="CONFIRMAR SENHA"  onChange={this.handlerChange.bind(this)} ></input>
        </div>
        <div className="row m-1 mt-3">
             <button className="btn-fill btn btn-success" onClick={this.atualizarCliente.bind(this)}>SALVAR ALTERAÇÕES</button>
        </div>
      </div>

    );
  }
}

export default PreencherCadastro;
